import { render, staticRenderFns } from "./editFaq.vue?vue&type=template&id=7646c6ce&scoped=true&"
import script from "./editFaq.vue?vue&type=script&lang=js&"
export * from "./editFaq.vue?vue&type=script&lang=js&"
import style0 from "./editFaq.vue?vue&type=style&index=0&id=7646c6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646c6ce",
  null
  
)

export default component.exports